import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Table structure matches https://acrisuremortgage.com/legal-licensing/ (5 columns).
// Agency column: not provided in New Website.docx — marked "—" pending Compliance/IT input.
// License Information column: entity name + NMLS number per state entry in the KB doc.
const STATE_LICENSES = [
  {
    state: 'Alabama',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Consumer Credit License',
    licenseNumber: '21815',
  },
  {
    state: 'Arkansas',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Combination Mortgage Banker‑Broker‑Servicer License',
    licenseNumber: '11173',
  },
  {
    state: 'Arizona',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Banker License',
    licenseNumber: '0904844',
  },
  {
    state: 'California',
    agency: 'Department of Financial Protection and Innovation (DFPI)',
    info: 'Licensed by the Department of Financial Protection and Innovation under the California Residential Mortgage Lending Act',
    licenseName: 'DFPI Residential Mortgage Lending Act License (RMLA)',
    licenseNumber: '4130289',
  },
  {
    state: 'Colorado',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Company Registration',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'Delaware',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #33825',
    licenseName: 'Licensed Lender',
    licenseNumber: '33825',
  },
  {
    state: 'District of Columbia',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Dual Mortgage License',
    licenseNumber: 'MLB3001',
  },
  {
    state: 'Florida',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Lender/Servicer License',
    licenseNumber: '897',
  },
  {
    state: 'Georgia',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Residential Mortgage Licensee',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'Idaho',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Broker/Lender License',
    licenseNumber: 'MBL‑802',
  },
  {
    state: 'Iowa',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Banker License',
    licenseNumber: '2004‑0179',
  },
  {
    state: 'Kansas',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Licensed Mortgage Company',
    licenseNumber: 'MC0025318',
  },
  {
    state: 'Kentucky',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Company License',
    licenseNumber: 'MC751526',
  },
  {
    state: 'Maine',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Supervised Lender License',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'Maryland',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Lender License',
    licenseNumber: '3001',
  },
  {
    state: 'Michigan',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'First Mortgage Broker/Lender/Servicer License',
    licenseNumber: 'FR0026477',
  },
  {
    state: 'Michigan',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Second Mortgage Broker/Lender/Servicer Registrant',
    licenseNumber: 'SR0019918',
  },
  {
    state: 'Mississippi',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Lender License',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'Nebraska',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Lender License',
    licenseNumber: '1964',
  },
  {
    state: 'Nevada',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001 | Branch NMLS #151941 | 9805 Double R Blvd., Suite 300, Office 3058, Reno, NV 89521',
    licenseName: 'Mortgage Company License',
    licenseNumber: '1198344 (NMA‑1198344)',
  },
  {
    state: 'Nevada',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Supplemental Servicer License',
    licenseNumber: '1198345 (NSMC‑1198345)',
  },
  {
    state: 'New Hampshire',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Banker License',
    licenseNumber: '3001MB',
  },
  {
    state: 'New Mexico',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Loan Company License',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'North Carolina',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #2767217',
    licenseName: 'Mortgage Lender License',
    licenseNumber: 'L‑209071',
  },
  {
    state: 'North Dakota',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Residential Mortgage Lender License',
    licenseNumber: 'ML104947',
  },
  {
    state: 'Ohio',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Residential Mortgage Lending Act Certificate of Registration',
    licenseNumber: 'RM850096',
  },
  {
    state: 'Oregon',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001 | Branch: 5600 S. Quebec Street, Suite 100‑D, Greenwood Village, CO 80111',
    licenseName: 'Mortgage Lending License',
    licenseNumber: 'ML‑4807',
  },
  {
    state: 'Pennsylvania',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #2767217',
    licenseName: 'Mortgage Servicer License',
    licenseNumber: '67753',
  },
  {
    state: 'South Carolina',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #2767217',
    licenseName: 'BFI Mortgage Lender/Servicer License',
    licenseNumber: 'MLS‑3001',
  },
  {
    state: 'South Dakota',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Lender License',
    licenseNumber: '3001ML',
  },
  {
    state: 'Tennessee',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage License',
    licenseNumber: '3001',
  },
  {
    state: 'Texas',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001. Complaints may be filed with the Texas Department of Savings and Mortgage Lending, 2601 N. Lamar, Suite 201, Austin, TX 78705 | www.sml.texas.gov | 1‑877‑276‑5550.',
    licenseName: 'Mortgage Banker Registration',
    licenseNumber: 'NMLS #3001',
  },
  {
    state: 'Utah',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Residential First Mortgage Notification',
    licenseNumber: 'UDFI‑RFMN2015',
  },
  {
    state: 'Utah',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Mortgage Entity License',
    licenseNumber: '6168217',
  },
  {
    state: 'Washington',
    agency: '—',
    info: 'Cherry Creek Mortgage, LLC NMLS #3001',
    licenseName: 'Consumer Loan Company License',
    licenseNumber: 'CL‑3001',
  },
];

const headerSx = {
  fontWeight: 700,
  bgcolor: '#1c1e2a',
  color: '#fff',
  whiteSpace: 'nowrap',
};

export default function LegalDisclosures() {
  return (
    <LegalPage title="CCM, LLC Legal Disclosures and License Information">
      <Typography variant="body1">
        It is CCM, LLC policy to comply with the Equal Credit Opportunity Act and the Fair Housing Act. In
        addition, it is CCM, LLC policy to comply with state laws that provide greater protection. CCM, LLC is an
        Equal Housing Lender, and does not engage in business practices that discriminate against any applicant on
        the basis of race; color; religion; creed; national origin; ancestry; sex; marital status; familial status
        (number and age of children); sexual orientation; age (provided that the applicant has the capacity to
        enter into a binding agreement); medical history; disability; physical condition; military status; because
        the applicant has in good faith exercised any right under the Consumer Credit Protection Act or
        Servicemembers Civil Relief Act (SCRA); that all or part of a consumer&rsquo;s income derives from a
        public assistance program; or any other basis prohibited by law. The federal agency that administers our
        compliance with these federal laws is the Federal Trade Commission, Equal Credit Opportunity, Washington,
        DC, 20580.
      </Typography>

      <Typography variant="h5">State Disclosure Requirements</Typography>
      <Typography variant="body1">CCM, LLC is a licensed mortgage lender in the following states:</Typography>

      <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={headerSx}>State</TableCell>
              <TableCell sx={headerSx}>Agency</TableCell>
              <TableCell sx={headerSx}>License Information</TableCell>
              <TableCell sx={headerSx}>License Name</TableCell>
              <TableCell sx={{ ...headerSx, whiteSpace: 'nowrap' }}>License Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {STATE_LICENSES.map((row, i) => (
              <TableRow key={i} sx={{ '&:nth-of-type(odd)': { bgcolor: '#f9fafb' } }}>
                <TableCell sx={{ fontWeight: 700, verticalAlign: 'top', whiteSpace: 'nowrap' }}>
                  {row.state}
                </TableCell>
                <TableCell sx={{ verticalAlign: 'top', color: row.agency === '—' ? '#919eab' : 'inherit' }}>
                  {row.agency}
                </TableCell>
                <TableCell sx={{ verticalAlign: 'top' }}>{row.info}</TableCell>
                <TableCell sx={{ verticalAlign: 'top' }}>{row.licenseName}</TableCell>
                <TableCell sx={{ verticalAlign: 'top', whiteSpace: 'nowrap' }}>{row.licenseNumber}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h5">CCM, LLC Legal Disclosures and License Information (cont.)</Typography>

      <Typography variant="body1">
        <strong>Affiliated Businesses:</strong> Cherry Creek Mortgage, LLC may maintain relationships with
        affiliated or commonly owned entities as permitted by law. Information regarding affiliated business
        arrangements will be provided separately when required.
      </Typography>

      <Typography variant="body1">
        <strong>Pre-Approval Disclosure:</strong> &ldquo;Pre-Approval&rdquo; refers to an automated underwriting
        system decision based on information provided by the applicant and is conditional upon review and
        verification of documentation by Cherry Creek Mortgage, LLC. Not all applicants will be approved.
      </Typography>

      <Typography variant="body1">
        <strong>Reverse Mortgage Risk Disclosure:</strong> Reverse mortgages involve significant financial
        implications. Key considerations include:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>A reverse mortgage is a loan that must be repaid</li>
        <li>
          Repayment may be required during the borrower&rsquo;s lifetime under certain circumstances, such as
          sale of the property or failure to occupy the home as a primary residence
        </li>
        <li>Foreclosure may occur if property taxes or insurance premiums are not paid</li>
        <li>Borrowers remain responsible for property taxes and insurance throughout the loan term</li>
        <li>Costs may vary, and less expensive alternatives may exist</li>
        <li>Reverse mortgages may affect eligibility for certain government benefits, including SSI and Medicaid</li>
        <li>
          Upon maturity, the loan balance may exceed the value of the home, and repayment of the full balance is
          required for the borrower or heirs to retain ownership
        </li>
      </Typography>
      <Typography variant="body1">
        Borrowers are encouraged to consult financial, tax, and housing counselors before entering into a reverse
        mortgage.
      </Typography>
    </LegalPage>
  );
}
